<template>
  <span v-if="probeValueRef" data-test-id="error-boundary-probe" />
</template>

<script setup lang="ts">
import { computed } from 'vue'

const probeValueRef = computed(() => {
  if (window.__CYPRESS_FORCE_RENDER_ERROR__) {
    throw new Error('Forced render error for ErrorBoundary test (KC-466)')
  }
  return null
})
</script>
